import React, { useEffect, useRef, useState } from "react";
import { MdFormatColorText, MdFormatColorFill, MdCheck } from "react-icons/md";

import { addMarkData, activeMark } from "./../utils/SlateUtilityFunctions.js";
import { Transforms, Editor } from "slate";
import { ReactEditor } from "slate-react";

const logo = {
  color: <MdFormatColorText size={20} />,
  bgColor: <MdFormatColorFill size={20} />,
};
const ColorPicker = ({ format, editor }: any) => {
  const [selection, setSelection] = useState();
  const [hexValue, setHexValue] = useState("");
  const [validHex, setValidHex] = useState<any>();
  const colorPickerRef = useRef(null);

  const isValideHexSix: any = new RegExp("^#[0-9A-Za-z]{6}");
  const isValideHexThree: any = new RegExp("^#[0-9A-Za-z]{3}");

  useEffect(() => {
    const val: any = Editor.marks(editor);
    const color = val?.[format];
    setHexValue("");
    if (color) {
      assignColorInput(color);
    }
  }, [JSON.stringify(editor)]);

  const assignColorInput = (color: string) => {
    if (color?.startsWith("var")) {
      const root = document.documentElement;
      const mainColorValue = getComputedStyle(root)
        .getPropertyValue(color.slice(4, -1).trim())
        .trim();

      setHexValue(mainColorValue);
      setValidHex(true);
    } else {
      setHexValue(color);
      setValidHex(true);
    }
  };

  const changeColor = (e: any) => {
    const clickedColor = e.target.getAttribute("data-value");
    selection && Transforms.select(editor, selection);
    assignColorInput(clickedColor);
    addMarkData(editor, { format, value: clickedColor });
    ReactEditor.focus(editor);
    Transforms.move(editor, {
      distance: 1,
    });
  };
  const toggleOption = () => {
    setSelection(editor.selection);
  };
  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    if (!validHex) return;
    selection && Transforms.select(editor, selection);

    addMarkData(editor, { format, value: hexValue });
    setValidHex("");
    setHexValue("");
  };
  const handleHexChange = (e: any) => {
    e.preventDefault();
    const newHex = e.target.value;
    setValidHex(isValideHexSix.test(newHex) || isValideHexThree.test(newHex));
    setHexValue(newHex);
  };
  return (
    <div className="" ref={colorPickerRef}>
      <p className="text-gray-600 mb-2 text-left text-sm font-semibold">
        Color de texto
      </p>
      <div>
        <div className="grid grid-cols-9 gap-2">
          {[
            "var(--primary100)",
            "var(--primary200)",
            "var(--primary300)",
            "var(--primary400)",
            "var(--primary500)",
            "var(--primary600)",
            "var(--primary700)",
            "var(--primary800)",
            "var(--primary900)",
            "#ffffff",
            "#000000",
            "#5ec190",
            "#173f5f",
            "#4d7ccf",
            "#7247db",
            "#e27c3a",
            "#ed553b",
            "#e8b647",
          ].map((color, index) => {
            return (
              <div
                key={index}
                data-value={color}
                onClick={changeColor}
                className="w-6 h-6 rounded-sm  hover:scale-110 border border-gray-300"
                style={{ background: color }}
              ></div>
            );
          })}
        </div>
        <p style={{ textAlign: "center", opacity: "0.7", width: "100%" }}>OR</p>
        <form onSubmit={handleFormSubmit} className="flex gap-5">
          <div
            className="w-6 h-6 rounded-sm border-gray-300"
            style={{ background: hexValue ? hexValue : "#000000" }}
          ></div>
          <input
            type="text"
            placeholder="#000000"
            value={hexValue}
            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            onChange={handleHexChange}
            style={{
              border:
                validHex === false ? "1px solid red" : "1px solid lightgray",
            }}
          />
          <button style={{ color: validHex ? "green" : "" }} type={"submit"}>
            <MdCheck size={20} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ColorPicker;
